import translationZH from '../../locales/zh/translation.json';
import translationDE from '../../locales/de/translation.json';
import translationEN from '../../locales/en/translation.json';
import translationES from '../../locales/es/translation.json';
import translationFR from '../../locales/fr/translation.json';
import translationJA from '../../locales/ja/translation.json';
import translationPT from '../../locales/pt/translation.json';
export const translations = {
    zh: {
        translation: translationZH
    },
    de: {
        translation: translationDE
    },
    en: {
        translation: translationEN
    },
    es: {
        translation: translationES
    },
    fr: {
        translation: translationFR
    },
    ja: {
        translation: translationJA
    },
    pt: {
        translation: translationPT
    }
};
